import { FAILURE } from '@front/common/constants'
import { getUpsellHighlightProduct } from '@front/common/endpoints'
import useAlert from '@front/ui/Alert/useAlert'
import { watch } from '@vue/composition-api'
import { useStore, useVuex } from '@vueblocks/vue-use-vuex'

import useApiState from '@member-area/core/hooks/useApiState'
import useAuth from '@member-area/middleware/auth.hook'

import { INSERT_UPSELL_HIGHLIGHT } from './constants'

const useUpsellHighlight = () => {
  const store = useStore()
  const { useGetters } = useVuex()
  const { triggerAlert } = useAlert()
  const { auth } = useAuth()

  const [
    onFetchUpsellHighlightSuccess,
    fetchUpsellHighlightState,
    fetchUpsellHighlightAction,
  ]: any[] = useApiState(getUpsellHighlightProduct)

  onFetchUpsellHighlightSuccess((data) => {
    if (!data) {
      return
    }

    store.commit(INSERT_UPSELL_HIGHLIGHT, data)
  })

  watch(fetchUpsellHighlightState, (state: any) => {
    const hasError = state.context.error

    return (
      hasError &&
      triggerAlert({
        status: FAILURE,
        message: 'Une erreur est survenue, veuillez recharger la page',
      })
    )
  })

  async function fetchUpsellHighlight() {
    return fetchUpsellHighlightAction(auth.value.id)
  }

  return {
    ...(useGetters({
      upsellHighlight: 'upsellHighlight/get',
    }) as any),
    fetchUpsellHighlightState,
    fetchUpsellHighlight,
  }
}

export default useUpsellHighlight
